import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { PaginatedResults } from '@app/interfaces/paginated-results';
import { Observable } from 'rxjs';
import { GalleryFiltersAndSorting } from '../interfaces/gallery-filters-and-sorting';
import { Image } from '../interfaces/image';
import { ImagePreview } from '../interfaces/image-preview';
import { PaginationResultsWithTags } from '../interfaces/pagination-results-with-tags';

@Injectable({
  providedIn: 'root',
})
export class ImagesService {
  constructor(private apiService: ApiService) {}

  get(imageId: number): Observable<Image> {
    return this.apiService.get<Image>('image/' + imageId.toString());
  }

  getGallery(
    filters: GalleryFiltersAndSorting,
    page: number = 1,
  ): Observable<PaginationResultsWithTags<ImagePreview>> {
    const data: any = {
      ...filters,
    };
    if (page > 1) {
      data.page = page;
    }
    return this.apiService.get<PaginationResultsWithTags<ImagePreview>>(
      'gallery',
      data,
    );
  }

  getFavorites(page: number = 1): Observable<PaginatedResults<ImagePreview>> {
    const data: any = {};
    if (page > 1) {
      data.page = page;
    }
    return this.apiService.getPaginatedResults<ImagePreview>('favorites', data);
  }

  addToFavorites(imageId: number): Observable<any> {
    return this.apiService.post<any>(
      'image/' + imageId.toString() + '/favorite',
    );
  }

  removeFromFavorites(imageId: number): Observable<any> {
    return this.apiService.delete<any>(
      'image/' + imageId.toString() + '/favorite',
    );
  }

  getRelatedImages(
    imageId: number,
    page: number = 1,
  ): Observable<PaginatedResults<ImagePreview>> {
    const data: any = {};
    if (page > 1) {
      data.page = page;
    }
    return this.apiService.get<PaginatedResults<ImagePreview>>(
      'image/' + imageId.toString() + '/related',
      data,
    );
  }
}
